module.exports = {
	"nl": {
		"static-pages": {
			"notFound": {
				"pageTitle": "Pagina niet gevonden.",
				"title": "Niet gevonden",
				"details": "We kunnen de applicatie die je zoekt niet vinden, weet je zeker dat je het adres juist hebt ingevoerd?",
				"goBack": "Ga terug"
			},
			"activation": {
				"pageTitle": "Beveiligde Omgeving",
				"title": "Welkom in de beveiligde omgeving",
				"activate": {
					"details": "Een momentje, we maken je activatielink aan...",
					"ready": "Je link is aangemaakt, klik op de knop om verder te gaan. Let op: deze link is maar één keer te gebruiken!",
					"go": "Activeer account"
				},
				"passwordReset": {
					"details": "Een momentje, we maken de link aan om je wachtwoord te resetten.",
					"ready": "Je link is aangemaakt, klik op de knop om verder te gaan. Let op: deze link is maar één keer te gebruiken!",
					"go": "Reset wachtwoord"
				},
				"error": {
					"details": "Er lijkt iets mis te zijn met je link. Probeer het nog een keer, of neem contact op met webwinkelsupport, en vermeld hierbij de code."
				}
			},
			"privacy-policy": {
				"pageTitle": "Privacybeleid van de Merchant Portal"
			},
			"terms-and-conditions": {
				"pageTitle": "Overeenkomst Merchant Portal"
			},
			"Support": {
				"pageTitle": "Support",
				"topic": {
					"orders": "Bestellingen",
					"settlements": "Afrekeningen",
					"agreements": "Overeenkomsten",
					"technical_issues": "Technische problemen",
					"others": "Overige"
				},
				"TicketList": {
					"title": "Supportverzoeken",
					"pageDescription": "Hier kun je de status van je supportverzoeken bekijken",
					"status": {
						"open": "Open",
						"pending": "In afwachting",
						"resolved": "Opgelost",
						"closed": "Afgesloten",
						"inProgress": "In uitvoering",
						"waitingForYourReply": "We wachten op je antwoord"
					},
					"TicketTable": {
						"id": "Verzoeken #",
						"mid": "Webwinkel/MID",
						"subject": "Onderwerp",
						"status": "Status",
						"updatedAt": "Laatste update"
					}
				},
				"EmptyTicketList": {
					"title": "Je hebt geen openstaande verzoeken"
				},
				"ticketDetails": {
					"sidebar": {
						"user": {
							"title": "Gebruiker"
						},
						"details": {
							"title": "Gegevens",
							"store": "Webwinkel/MID",
							"createdAt": "Datum verzoek",
							"updatedAt": "Laatste update"
						},
						"actions": {
							"close": "Verzoek sluiten",
							"reopen": "Verzoek heropenen"
						},
						"closeTicketDialog": {
							"confirm": "Bevestigen",
							"title": "Verzoek sluiten",
							"description": "Je staat op het punt dit verzoek te sluiten. Je kunt het alleen binnen de komende 7 dagen heropenen.",
							"error": "Oeps! Er is iets misgegaan, probeer het nog eens."
						},
						"reopenTicketDialog": {
							"title": "Verzoek heropenen",
							"description": "Vertel ons waarom je dit verzoek moet heropenen en we nemen zo snel mogelijk contact met je op.",
							"messageLabel": "Bericht"
						}
					},
					"conversation": {
						"loadMore": "Meer laden",
						"title": "Verzoek",
						"attachments": {
							"label": "Bijlagen"
						},
						"reply": {
							"title": "Antwoord toevoegen",
							"body": {
								"label": "Een antwoord toevoegen",
								"error": null
							},
							"attachment": {
								"label": "Bijlagen toevoegen",
								"error": "De totale bestandsgrootte mag niet meer zijn dan 15 MB"
							},
							"add": "Antwoord toevoegen",
							"cancel": "Annuleren",
							"submit": {
								"label": "Verzenden",
								"error": "Je antwoord is niet opgeslagen, probeer het later opnieuw."
							}
						}
					}
				},
				"errorView": {
					"429": {
						"title": "Oeps!",
						"message": "Er is iets misgegaan, probeer het over een paar minuten nog eens. Als het probleem zich blijft voordoen, neem dan contact met ons op.",
						"contact": "Wanneer je contact opneemt met support, geef dan het volgende Correlation-ID door",
						"action": "Neem contact met ons op"
					},
					"error": "Fout",
					"default": {
						"title": "Oeps, er is iets fout gegaan",
						"message": "Vanwege een of ander probleem aan onze kant, konden we je verzoek niet uitvoeren. Probeer het opnieuw of kom later nog eens terug.",
						"contact": "Wanneer je contact opneemt met support, geef dan het volgende Correlation-ID",
						"action": "Herladen"
					}
				}
			},
			"Marketing": {
				"pageTitle": "Grab en Go Marketing",
				"banner": {
					"title": "Welkom bij Grab en Go Marketing!",
					"subtitle": "Hier vind je kant-en-klare functionaliteiten voor je website, e-mailcampagnes en sociale-mediamarketing.",
					"button": "Ontdek meer"
				},
				"productSection": {
					"title": "Welk Klarna-product bied je je klanten aan?"
				},
				"MarketSelector": {
					"label": "Selecteer markt",
					"markets": {
						"BE": "België (Nederlands)",
						"BE-FR": "België (Frans)"
					}
				},
				"ChannelSelector": {
					"pageTitle": {
						"kco": "Klarna Checkout",
						"fourInstallments": "4 Termijnen",
						"pin30": "Betalen in 30 dagen"
					}
				},
				"sourceAndPreview": {
					"helpButton": "Hulp nodig?",
					"copyButton": "Kopieer naar klembord",
					"copyButtonSuccess": "Gekopieerd!",
					"sourceButton": "Bron",
					"previewButton": "Preview"
				},
				"EmailTemplates": {
					"pageTitle": "E-mailtemplates",
					"title": "E-mailtemplates"
				},
				"EmailHeader": {
					"pageTitle": "E-mail marketingafbeelding",
					"title": "E-mail marketingafbeelding"
				},
				"Social": {
					"pageTitle": "Sociale media",
					"title": "Sociale media"
				},
				"buttonDownload": "Download afbeelding",
				"buttonCopy": "Kopieer tekst",
				"buttonCopySuccess": "Gekopieerd!",
				"missingPreview": "Preview ontbreekt",
				"productLinkText": "Ontdek nu",
				"content": {
					"products": {
						"kco": {
							"title": "Klarna Checkout",
							"subtitle": "Een complete Checkout-oplossing met alles op één plek."
						},
						"payNow": {
							"title": "Betaal nu",
							"subtitle": "Laat klanten direct betalen voor hun aankoop."
						},
						"threeInstallments": {
							"title": "3 Termijnen",
							"subtitle": "Geef je klanten de vrijheid om de kosten rentevrij te spreiden."
						},
						"fourInstallments": {
							"title": "4 Termijnen",
							"subtitle": "Geef je klanten de vrijheid om de kosten rentevrij te spreiden."
						},
						"pin14": {
							"title": "Betalen in 14 dagen",
							"subtitle": "Betaal in 14 dagen. Geen rente of extra kosten."
						},
						"pin21": {
							"title": "Betalen binnen 21 dagen",
							"subtitle": "Betaal in 21 dagen. Geen rente of extra kosten."
						},
						"pin30": {
							"title": "Betalen in 30 dagen",
							"subtitle": "Betaal in 30 dagen. Geen rente of extra kosten."
						},
						"financing": {
							"title": "Financiering",
							"subtitle": "Boost je verkopen door klanten tot 36 maanden de tijd te geven om te betalen."
						}
					},
					"campaigns": {
						"holidays-2020": {
							"title": "Feestdagen 2020",
							"channels": {
								"emailHeader": {
									"title": "E-mail marketingafbeelding",
									"subtitle": "Laat je abonnees deze feestdagen met de ogen knipperen met afbeeldingen van studiokwaliteit voor je e-mailcampagnes.",
									"linkText": "Bekijk afbeeldingen",
									"introduction": "Het is tijd om je abonnees in te lichten over je geweldige aanbiedingen en kortingen voor de feestdagen. Download voor de grootste impact een afbeelding en voeg deze toe aan je e-mailcampagne of e-mail template header."
								},
								"social": {
									"title": "Sociale media",
									"subtitle": "Lok meer klanten naar je winkel tijdens de feestdagen met deze gratis te gebruiken afbeeldingen.",
									"linkText": "Bekijk posts",
									"introduction": "Het is tijd om aan de wereld te verkondigen dat je aanbiedingen en kortingen voor de feestdagen biedt! Je hoeft alleen maar de functionaliteiten te downloaden en ze te uploaden naar je socialemediaprofielen of planningstool. Vergeet niet om {link} in je berichten te taggen om nog meer bezoekers en conversies te bereiken."
								}
							},
							"imageAlt": {
								"holiday1": "Persoon in een kleurrijk pak buigt op één knie naar een dweil; in één hand een zilveren schoen, in de andere een smartphone.",
								"holiday2": "Persoon in bordeauxrode pyjama zweeft in kleermakerszit boven een ventilator met een zwevende smartphone op ooghoogte."
							}
						},
						"at-launch": {
							"title": "Bij de lancering",
							"subtitle": "Ben je pas net met ons begonnen? Gebruik deze functionaliteiten om bestaande en nieuwe klanten te vertellen dat je live bent met Klarna.",
							"channels": {
								"email": {
									"title": "E-mailtemplates",
									"subtitle": "Laat je abonnees weten dat er een nieuwe manier is om te betalen.",
									"linkText": "Bekijk templates",
									"introduction": "Het is tijd om je abonnees te laten weten dat je met Klarna bent gestart! Kopieer en plak het template of de content naar je e-mailplatform en je kunt aan de slag.",
									"codeBoxTitle": "E-mail voor lancering"
								},
								"social": {
									"title": "Sociale media",
									"subtitle": "Lok meer klanten naar je winkel met deze smoooth foto's van studiokwaliteit.",
									"linkText": "Bekijk posts",
									"introduction": "Het is tijd om aan de wereld te verkondigen dat je met Klarna bent begonnen! Je hoeft alleen maar de functionaliteiten te downloaden en ze te uploaden naar je socialemediaprofielen of planningstool. Vergeet niet om {link} te taggen in je aankondigingen om nog meer bezoekers en conversies te bereiken."
								},
								"osm": {
									"title": "Landingspagina's",
									"subtitle": "Denk mee met je klant en informeer ze over hoe te winkelen met Klarna.",
									"linkText": "Bekijk pagina's"
								}
							},
							"imageAlt": {
								"emotional": "Persoon met lang, krullend haar in paarse jumpsuit spelend op een chromen flipperkast",
								"paymentShowcase": "Een hand die een telefoon vasthoudt met het Klarna-logo, rolschaatsen op de achtergrond",
								"simplified": "Telefoon naar beneden gericht op een chromen flipperkast aan de rechterkant, felgele bank aan de linkerkant",
								"device": "Een telefoon met een hangend Klarna-logo vanuit de buitenkant van het kader, roze kamer met kroonluchter op de achtergrond"
							}
						}
					}
				}
			}
		}
	}
};